import { useRef, useState } from "react";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import TextTagged from "@/utils/text-tagged-render";
import { confirmLinkJump } from "@/utils/public";
import GoLink from "@/static/golink.png";
import "./index.less";
import { useBlockNoSameDomainClick } from "@sui/chat-ui";

const { Panel } = Collapse;

const titleNode = (
  <div className="jump-tips">
    您访问的链接即将跳转当前网站，是否继续？
    {/* 您访问的链接即将离开
    <img src={GoLink} width="160" alt="链接" />
    <br />
    是否继续？ */}
  </div>
);

function ReferenceMessageCard({ msg, chatInstance }) {
  const {
    reference: { referenceList = [], text },
  } = msg;
  const refs = useRef([]);
  const [activeKey, setActiveKey] = useState(["0"]);

  const handleLinkClick = useBlockNoSameDomainClick()

  const handleClick = (key) => {
    if (!activeKey.length) {
      setActiveKey(["0"]);
    }
    const targetRect = refs.current[key].getBoundingClientRect();
    const containerRect = window.ChatRoot.getBoundingClientRect();
    window.ChatRoot.scrollTo({
      top: targetRect.top - containerRect.top + window.ChatRoot.scrollTop,
      behavior: "smooth",
    });
  };

  const onChange = () => {
    if (!activeKey.length) {
      setActiveKey(["0"]);
    } else {
      setActiveKey([]);
    }
  };

  return (
    <div className="card_reference">
      <div className="msg-line">
        <div className="card_reference__text">
          <TextTagged text={text} onClick={handleClick} />
        </div>
        {referenceList.length ? (
          <div className="card_reference__list">
            <Collapse activeKey={activeKey} onChange={onChange} ghost>
              <Panel
                header={
                  <>
                    参考资料
                    <DownOutlined className="reference-title" />
                  </>
                }
                key={"0"}
                forceRender={true}
                showArrow={false}
              >
                {referenceList.map(
                  (item, index) => {
                    return (
                      <div
                        ref={(el) => (refs.current[index] = el)}
                        className="reference-collapse"
                        key={index}
                      >
                        <Collapse ghost>
                          <Panel
                            key={index}
                            header={
                              <>
                                {item.url ? (
                                  <a
                                    href={item.url}
                                    target="_blank"
                                    onClick={handleLinkClick}
                                  >
                                    {index + 1}. {item.title}
                                  </a>
                                ) : (
                                  index + 1 + ". " + item.title
                                )}
                                <DownOutlined />
                              </>
                            }
                            showArrow={false}
                            className="child-collapse-panel"
                          >
                            <div className="reference-collapse-info">
                              {item.content}
                            </div>
                          </Panel>
                        </Collapse>
                      </div>
                    );
                  }
                )}
              </Panel>
            </Collapse>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ReferenceMessageCard;
